const fileValidator = {
  data() {
    return {
      fileImageTypes: [
        "image",
        "apng",
        "bmp",
        "gif",
        "ico",
        "jpg",
        "jpeg",
        "jfif",
        "pjpeg",
        "pjp",
        "png",
        "svg",
        "webp",
      ],
      fileVideoTypes: ["video", "avi", "mpeg", "ogv", "webm", "ogg", "mp4"],
    };
  },
  methods: {
    fileIsPdf(file) {
      if (!file || (!file.url && !file.name)) {
        return false;
      }
      const url = (file.url || "").toLowerCase();
      const name = (file.name || "").toLowerCase();
      const urlExt = url.split(".").pop() || "";
      const nameExt = name.split(".").pop() || "";
      if (
        urlExt === "pdf" ||
        nameExt === "pdf" ||
        name.includes(".pdf") ||
        url.includes(".pdf")
      ) {
        return true;
      }
      const type = file.type
        ? String(file.type).toLowerCase()
        : url.split(".").pop();
      return type == "application/pdf" || type == "pdf";
    },
    fileIsImage(file) {
      if (!file) {
        return false;
      }
      let type = file.type
        ? file.type.split("/")[0]
        : file.url.split(".").pop();
      return this.fileImageTypes.includes(type.toLowerCase());
    },
    fileIsMkvVideo(file) {
      if (!file) {
        return false;
      }
      let type = file.type
        ? file.type.split("/")[0]
        : file.url.split(".").pop();
      return type.toLowerCase() == "mkv";
    },
    fileIsVideo(file) {
      if (!file) {
        return false;
      }
      let type = file.type
        ? file.type.split("/")[0]
        : file.url.split(".").pop();
      return this.fileVideoTypes.includes(type);
    },
    getFileTypeVideoSource(file) {
      return !file.type
        ? "video/" + file.url.split(".").pop()
        : file.type.includes("video")
        ? file.type
        : `video/${file.type}`;
    },
  },
};

export default fileValidator;
